module.exports = __webpack_public_path__ + "static/media/quotegreen.f029ad42.png";